<template>
  <slot v-bind="{ searchForm: slotProps, click, canSend }"></slot>
</template>

<script>
export default {
  data () {
    return {
      slotProps: {
        clicked: false,
        q: '',
        input: null,
      },
    }
  },
  methods: {
    click() {
      this.slotProps.clicked = !this.slotProps.clicked
      if (this.slotProps.clicked && this.slotProps.input)
        this.slotProps.input.focus()
    },
    canSend(e) {
      if (this.slotProps.q == '')
        e.preventDefault()        
    }
  }
}
</script>